<app-admin-header style="width: 100%;" [header]="header" [links]="links" [breadcrumbs]="breadcrumbs"
    [stats]="[]"></app-admin-header>
<section class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">{{'Enquiries' | translator}}</h4>
            </div>
            <app-project-step [step]="'Enquiries'" [projectId]="projectId"></app-project-step>
        </div>

        <app-project-details-card *ngIf="channels && project && !skelition" [project]="project"
            [channels]="basicChannels" [branches]="selectedBranches"></app-project-details-card>
        <p-messages [(value)]="messages" [enableService]="false"></p-messages>
        <div class="white-box" *ngIf="!(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) && !(statusType == 'Approved' || statusType == 'Pending') ">
            <div>
                <h4 class="semi-h-pg-4">{{'Enquiries' | translator}}</h4>
            </div>
            <div class="grey-box">
                <div class="row pg-6-px-4">
                    <div class="col-md-6 col-12">
                        <div class="width-100">
                            <h4 class="medium-h my-2">{{'Enquiry' | translator}}</h4>
                            <div class="d-flex align-items-baseline">
                                <input type="text" class="form-control ms-input-white-pg-5"
                                    [(ngModel)]="enquiry.enquiry" placeholder="" id="exampleInputEmail1"
                                    aria-describedby="emailHelp">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-12">
                        <div class="width-100">
                            <h4 class="medium-h my-2">{{'Correct Answer' | translator}}</h4>
                            <div class="d-flex align-items-baseline">
                                <input type="text" class="form-control ms-input-white-pg-5"
                                    [(ngModel)]="enquiry.correctAnswer" placeholder=""
                                    id="exampleInputEmail1" aria-describedby="emailHelp">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-12">
                        <div>
                            <h4 class="medium-h my-2">{{'Factor' | translator}}</h4>
                            <div class="d-flex align-items-baseline">
                                <select class="form-control ms-input-white-pg-5" [(ngModel)]="enquiry.factorId">
                                    <option *ngFor="let item of factors" [value]="item._id">{{item.factor}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-12">
                        <div class="width-100">
                            <h4 class="medium-h my-2">{{'Service URL' | translator}}</h4>
                            <div class="d-flex align-items-baseline">
                                <input type="text" class="form-control ms-input-white-pg-5"
                                    (click)="showSelectServiceModal = true"
                                    [value]="getServiceURL()"
                                    placeholder="" id="exampleInputEmail1"
                                    [disabled]="true"
                                    aria-describedby="emailHelp">
                                <div (click)="showSelectServiceModal = true" class="ms-plus-btn mx-2">
                                    <i class="pi pi-list"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="!(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) && !(statusType == 'Approved' || statusType == 'Pending') " class="d-flex justify-content-center">
            <button class="submmit-btn" (click)="postEnquiry()">{{'Create' | translator}}</button>
        </div>

        <div class="white-box">
            <h4 class="semi-h-pg-4">{{'Enquiries' | translator}}</h4>
            <div class="grey-box">
                <table>
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">{{'Enquiry' | translator}}</th>
                            <th scope="col">{{'Correct Answer' | translator}}</th>
                            <th *ngIf="!(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null))" scope="col">{{'Factor' | translator}}</th>
                            <th scope="col">{{'Service URL' | translator}}</th>
                            <th *ngIf="!(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null))" scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let enquiry of enquiries;let i=index">
                            <td style="width:0px" data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                {{i + 1}}
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                            <td data-label="Enquire"><span class="ms-tabel-td-mob-mr">
                                    <div [pTooltip]="enquiry.enquiry" tooltipPosition="top" class="tabel-detail-box">
                                        {{enquiry.enquiry.substring(0,15)}} {{enquiry.enquiry.length > 15 ? "..." : null}}
                                    </div>
                                </span></td>
                            <td data-label="Correct Answer"><span class="ms-tabel-td-mob-mr">
                                    <div [pTooltip]="enquiry.correctAnswer" tooltipPosition="top" class="tabel-detail-box" [ngStyle]="{'cursor': 'pointer'}">
                                        {{enquiry.correctAnswer.substring(0,15)}} {{enquiry.correctAnswer.length > 15 ? "..." : null}}
                                    </div>
                                </span></td>
                            <td *ngIf="!(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null))" data-label="Correct Answer"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">{{enquiry?.factorId?.factor}}</div>
                                </span></td>
                            <td data-label="Service URL">
                                <span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">
                                        <a [href]="locationOrigin + '/data/' + enquiry.serviceUrl"  target="_blank">
                                            <i *ngIf="enquiry.ChangeInService" class="pi pi-exclamation-circle text-danger" [title]="'Change in Service' | translator "></i>
                                            {{ locationOrigin + '/data/' + enquiry.serviceUrl }}
                                        </a>
                                    </div>
                                </span>
                            </td>
                            <td *ngIf="!(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) && !(statusType == 'Approved' || statusType == 'Pending')" data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tabel-btn-black-box mob-m-tb-pg-3">
                                        <div class="tabel-circle-btn" (click)="confirmDelete(enquiry._id)" ><i class="fa fa-trash"></i></div>
                                        <div class="tabel-circle-btn" (click)="updateEnquiry(enquiry)" ><i class="fa fa-pencil"></i></div>
                                    </div>
                                </span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div *ngIf="!(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) && (statusType == '' || statusType == 'Redo' || statusType == 'Change') " class="d-flex justify-content-end gap-1">
                <button class="next-btn" (click)="submitForApproval()" >{{'SubmitMS' | translator}}</button>
            </div>
        </div>

        <ng-container *ngIf="(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) && statusType == 'Pending'">
            <div class="my-4 bg-comment-color mx-1">
                <h5 class="medium-h-v4 p-3">{{'Comments' | translator}}</h5>
                <input class="ms-input-textarea" type="textarea" 
                    [(ngModel)]="pmComment" placeholder="">
            </div>
            <div class="d-flex justify-content-center gap-1">
                <button (click)="redoStatus()" class="re-do-btn mx-2">{{'Redo' | translator}} <i
                    class="fa-solid fa-arrows-rotate mx-2"></i></button>
                <button (click)="approveStatus()" class="next-btn">{{'Approve' | translator}} <i
                    class="pi pi-check-circle mx-2"></i></button>
            </div>
        </ng-container>
        <ng-container *ngIf="statusType != ''">
            <div class="my-4 bg-comment-color mx-1" align="center">
                <h5 class="medium-h p-3" [ngClass]=" statusType == 'Approved' ? 'text-success' : (statusType == 'Change' ? '' : (statusType == 'Pending' ? '' : 'text-danger'))">
                    <ng-container *ngIf="statusType === 'Change' || statusType === 'Pending'; else defaultTemplate">
                        {{ 'Enquiries' | translator }} {{ ('are in ' + statusType + ' State') | translator }}
                    </ng-container>
                    <ng-template #defaultTemplate>
                        {{ ('are in ' + statusType + ' State') | translator }} {{ (statusType == 'Approved') ?  ('Enquiries' | translator) : '' }}
                    </ng-template>
                </h5>
                <h5 *ngIf="statusType == 'Redo' || statusType == 'Change'" class="medium-h p-3">{{ pmComment }}</h5>
            </div>
        </ng-container>
        <ng-container *ngIf="(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) && statusType == 'Approved'">
            <div class="my-4 bg-comment-color mx-1">
                <h5 class="medium-h-v4 p-3">{{'Comments' | translator}}</h5>
                <input class="ms-input-textarea" type="textarea" 
                    [(ngModel)]="pmComment" placeholder="">
            </div>
            <div class="d-flex justify-content-center gap-1">
                <button (click)="requestChange()" class="next-btn">{{'Request Change' | translator}}</button>
            </div>
        </ng-container>
        <div class="d-flex justify-content-between">
            <button [routerLink]="'/ms/criterias/'+projectId"  class="next-btn">{{'Back' | translator}} <i
                    class="pi pi-arrow-right mx-2"></i></button>
            <button [routerLink]="'/ms/calender/' + projectId" class="next-btn">{{'Next' | translator}} <i
                    class="pi pi-arrow-left mx-2"></i></button>
        </div>
    </div>
</section>
<p-confirmDialog [style]="{margin: '0rem 1rem'}"></p-confirmDialog>
<p-dialog [blockScroll]="true" [draggable]="false" [header]="'Select Service' | translator" [maximizable]="true" [(visible)]="showSelectServiceModal"
    [style]="{ width:'95vw', maxWidth:'1700px',maxHeight:'900px'}">
    <div>
        <app-select-service (currentDataItem)="setServiceLink($event)"></app-select-service>
    </div>
</p-dialog>
<app-footer></app-footer>